import isNullish from "utils/isNullish";

export const getTermRowId = (term, isByParagraph) =>
  isByParagraph
    ? term.paragraphId
    : `${term.paragraphId}-${term.sentenceIndex}`;

const PARAGRAPH_KEY_PREFIX = "p";
const SENTENCE_KEY_PREFIX = "s";

export const toValueKey = ({ paragraphId, sentenceStart }) =>
  isNullish(sentenceStart)
    ? `${PARAGRAPH_KEY_PREFIX}:${paragraphId}`
    : `${SENTENCE_KEY_PREFIX}:${paragraphId}:${sentenceStart}`;

export const getValueKey = (term, isByParagraph) =>
  toValueKey({
    paragraphId: term.paragraphId,
    sentenceStart: isByParagraph ? null : term.sentenceIndex,
  });

export const parseValueKey = (valueKey) => {
  const [prefix, paragraphId, sentenceStart] = valueKey.split(":");
  return {
    paragraphId: Number(paragraphId),
    sentenceStart:
      prefix === SENTENCE_KEY_PREFIX ? Number(sentenceStart) : null,
  };
};
